export default __webpack_public_path__ + "static/pexels-burst-374020-97b36be2b9bcab986b82c5a2ba33f95b.jpg";